
import NewAssessmentContainer from './new/NewAssessmentContainer';
import AssessmentTempEdit from './templates/edit/DetailContainer';
import AssessmentListContainer from './AssessmentListContainer';
import AssessmentTemplatesContainers from './templates/AssessmentTemplatesContainers';
import AssessmentTempNewContainer from './templates/new/AssessmentTempNewContainer';
import AssessmentDetail from './details/AssessmentDetail';

const assessmentRoutes = [
  {
    exact: true,
    path: '/accounts/:aid/assessments/',
    component: AssessmentListContainer,
  },
  {
    path: '/accounts/:aid/assessments/templates/new',
    component: AssessmentTempNewContainer,
  },
  {
    path: '/accounts/:aid/assessments/templates/:templateId',
    component: AssessmentTempEdit,
  },
  {
    path: '/accounts/:aid/assessments/templates',
    component: AssessmentTemplatesContainers,
  },
  {
    path: '/accounts/:aid/assessments/new/:respondentId',
    component: NewAssessmentContainer,
  },
  {
    path: '/accounts/:aid/assessments/:assessmentId',
    component: AssessmentDetail,
  },
];

export default assessmentRoutes;
